"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const material_1 = require("@mui/material");
const lexico_1 = __importDefault(require("@tradeshift/lexico"));
const empty_wallet_state_illustration_svg_1 = __importDefault(require("../../../../../../assets/img/empty-wallet-state-illustration.svg"));
const lexico = new lexico_1.default();
const EmptyMyCardsListWallet = () => {
    const theme = (0, material_1.useTheme)();
    return ((0, jsx_runtime_1.jsxs)(material_1.Box, { sx: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            flexDirection: 'column',
            margin: 'auto',
            width: '450px',
            paddingTop: theme.tsGoUnit.tsUnitDouble,
        }, children: [(0, jsx_runtime_1.jsx)("img", { src: empty_wallet_state_illustration_svg_1.default, alt: "", "data-testid": "empty-wallet-image" }), (0, jsx_runtime_1.jsx)("h2", { "data-testid": "empty-wallet-header", children: lexico.tr('No more virtual cards left in your wallet.') })] }));
};
exports.default = EmptyMyCardsListWallet;
